import { GridApplication } from 'src/app/+grid-application-shared/entities/gridApplication';

export const LookupKeys = {
  ConsumptionDeviceType: 'sk_consumption_device_type',
  HeatingPumpType: 'sk_heating_pump_type',
  ModuleChoice: 'sk_module_choice',
  AirConditioningType: 'sk_air_conditioning_type',
  WallBoxType: 'sk_wall_box_type',
  LoadManagementType: 'sk_load_management_type',
  CouplingType: 'sk_coupling_type',
};

export class DrrCcdDeviceApplicationDto extends GridApplication {
  is_registration_device?: boolean;
  is_consumption_device?: boolean;
  network_connection_point_power?: number;
  consumption_devices?: ConsumptionDeviceDto[];
  is_commissioning_done?: boolean;
  is_commissioning_confirmed?: boolean;
  commissioning_date?: string;
  commissioning_document_id?: number;
  commissioning_document?: SimpleDocumentDto;
}

export interface GenDocumentDto {
  document_id: number;
  application_id?: number;
  offer_id?: number;
  order_id?: number;
  invoice_id?: number;
  sk_document_type?: string;
  name?: string;
  filename?: string;
  content?: string;
  content_type?: string;
  template?: string;
  example?: number;
  filepath?: string;
  photovoltaic_id?: number;
  inverter_id?: number;
  generator_id?: number;
  converter_id?: number;
  power_plant_protection_id?: number;
  integrated_protection_id?: number;
}

export interface SimpleDocumentDto {
  document_id: number;
  name?: string;
  document_type?: string;
  content?: string;
  content_type?: string;
}

export interface DeviceUnitDto {
  id: number;
  manufacturer?: string;
  designation_type?: string;
  power?: number;
  data_sheet_document?: SimpleDocumentDto;
  heater_power?: number;
  has_additional_heating?: boolean;
  data_sheet_wr_document_id?: number;
  data_sheet_wr_document?: SimpleDocumentDto;
  coupling_type?: string;
  has_load_management?: boolean;
  load_management_type?: string;
  parent_device_id?: number;
  parent_device?: DeviceUnitDto;
  children_devices?: DeviceUnitDto[];
  consumption_device_id: number;
  unavailable: boolean;
  circuit_diagram_document_id?: number;
  circuit_diagram_document?: SimpleDocumentDto;
}

export class ConsumptionDeviceDto {
  id: number;
  device_type?: string;
  pump_type?: string;
  air_conditioning_type?: string;
  wall_box_type?: string;
  total_grid_power_consumption?: number;
  type_of_control?: string;
  module_choice?: string;
  is_cascade_measurement: boolean;
  is_separate_meter_required: boolean;
  meter_number?: string;
  meter2?: string;
  device_units?: DeviceUnitDto[];
  drr_ccd_device_application_id: number;
  data_sheet_document: GenDocumentDto;
  data_sheet_wr_document: GenDocumentDto;
  other_type?: string;
}

//#region FORM MODELS
export interface CcdDrrDevicesFormModel {
  applicationId: number;
  type: string;
  devices: DeviceWrapperFormModel[];
  simultaneouslyRequiredPower: number;
  commissioningDate?: Date | null;
  isCommissioningDone?: boolean | null;
  isCommissioningConfirmed?: boolean | null;
  commissioningDocument?: FileFormModel;
  commissioningDocumentId?: number;
}

export interface FileFormModel {
  id?: number;
  name: string;
  documentType?: string;
  file: any; // Consider specifying a more precise type instead of 'any'
  contentType: string | null;
}

export interface DeviceUnitFormModel {
  id: number;
  consumptionDeviceId: number;
  manufacturer: string;
  designationType: string;
  electricalPower: number;
  powerOfAdditionalHeater: number;
  hasAdditionalHeating: boolean;
  unavailable: boolean;
  loadManagementAvailable: boolean | null;
  loadManagementType: string | null;
  couplingType: string;
  subUnits?: DeviceUnitFormModel[];
  dataSheet?: FileFormModel;
  dataSheetWr?: FileFormModel;
  circuitDiagramDocument?: FileFormModel;
}

export interface DeviceUnitsFormModel {
  units: DeviceUnitFormModel[];
}

export interface DeviceFormModel {
  id?: number;
  rawValue?: DeviceFormModel;
  ccdType: string;
  heatingPumpType: string;
  airConditioningType: string | null;
  wallBoxType: string | null;
  other: string | null;
  totalConsumption: number;
  typeOfControl: string;
  module: string;
  cascadeMeasurementDesired: boolean;
  separateMeterRequired: boolean;
  meterNumber: string | null;
  meter2: string | null;
  deviceUnits: DeviceUnitsFormModel;
}

export interface DeviceWrapperFormModel {
  device: DeviceFormModel;
}
//#endregion

export const ccdTypes = {
  heatPump: 'heat_pump',
  airConditioner: 'air_conditioner',
  wallBox: 'wall_box',
  storage: 'storage',
};

export interface DrrCcdCommissioningData {
  commissioning_date?: Date;
  is_commissioning_done?: boolean;
  is_commissioning_confirmed?: boolean;
  commissioning_document_id?: number;
  commissioning_document?: FileFormModel;
}

export enum DrrCcdDocumentTypes {
  DataSheet = 'drr_ccd_data_sheet',
  DataSheetWR = 'drr_ccd_data_sheet_wr',
  CommissioningDocument = 'drr_ccd_commissioning',
  CircuitDiagramDocument = 'drr_ccd_circuit_diagram',
}
